<template>
  <header aria-label="Top" class="bg-white sticky top-0 z-10 flex-none">
    <div class="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
      <div class="flex items-center h-16">
        <div class="justify-start shrink-0">
          <NuxtLink to="/">
            <span class="sr-only">checkandrent.com</span>
            <Icon
              name="i-custom-logo-text-dark"
              alt="checkandrent.com"
              class="hidden w-72 h-10 md:block"
            />
            <Icon
              name="i-custom-logo"
              alt="checkandrent.com"
              class="size-10 md:hidden"
            />
          </NuxtLink>
        </div>
        <slot />
      </div>
    </div>
  </header>
</template>
